const regions = [
    {
        code: 'EU',
        source: 'A01',
        countries: [
            'AT',
            'BE',
            'CH',
            'CZ',
            'DE',
            'DK',
            'ES',
            'FI',
            'FR',
            'GB',
            'HR',
            'HU',
            'IE',
            'IT',
            'NL',
            'NO',
            'PL',
            'PT',
            'RO',
            'RS',
            'RU',
            'SE',
            'SI',
            'SK',
        ],
    },
    { code: 'NA', source: 'A03', countries: ['CA', 'US'] },
    { code: 'CN', source: 'A04', countries: ['CN'] },
    { code: 'AP', source: 'A02', countries: ['JP', 'KR', 'IN', 'AU', 'NZ'] },
] as const;

const DEFAULT_REGION = 'EU';
const DEFAULT_SOURCE = 'A01';

const countryToRegion = new Map<string, string>();
const countryToSource = new Map<string, string>();
const regionToCountries = new Map<string, readonly string[]>();

for (const region of regions) {
    regionToCountries.set(region.code, region.countries);

    for (const country of region.countries) {
        countryToRegion.set(country, region.code);
        countryToSource.set(country, region.source);
    }
}

export const getRegion = (countryCode: string | undefined): string => {
    if (!countryCode) {
        return DEFAULT_REGION;
    }

    return countryToRegion.get(countryCode) ?? DEFAULT_REGION;
};

export const getSource = (countryCode: string | undefined): string => {
    if (!countryCode) {
        return DEFAULT_SOURCE;
    }

    return countryToSource.get(countryCode) ?? DEFAULT_SOURCE;
};

export const getCountries = (regionCode: string | undefined): readonly string[] => {
    if (!regionCode) {
        return [];
    }

    return regionToCountries.get(regionCode) ?? [];
};
